export const actionTypes = {
  CHAGE: "CHANGE_NOTIFY",
};

export const changeNotify = (payLoad) => {
  const defaultTime = 30000; 

  return {
    type: actionTypes.CHAGE,
    payLoad: {
      ...payLoad,
      time: payLoad.duration || payLoad.time || defaultTime,
    },
  };
};